import { styled } from 'styled-components';

import { autocompleteClasses, Popper } from '@mui/material';

export const ItemOption = styled(Popper)({
  [`& .${autocompleteClasses.listbox}`]: {
    boxSizing: 'border-box',
    '& ul': {
      padding: 0,
      margin: 0,
    },
  },
});
